import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { Contratistas } from './contratistas.model';

@Injectable({
  providedIn: 'root'
})
export class ContratistasService {
  listContratista!: Contratistas[];
  private routeApi = "AdmContratistas";
  private urlMassive = "AdmContratistaMasivo";

  constructor(
    private generalHttp: GeneralHttpService
  ) { }

  getContratistaInProgramByDocument(doc: string, idEmpresa: number) {
    return this.generalHttp.getHttpById(idEmpresa, this.routeApi + "/InProgramByDocument/" + doc).then(r => this.listContratista = r as Contratistas[])
  }


  getContratistaByDocument(docNumber: string, docType: number) {
    return this.generalHttp.getHttpById(docType, "PacProgramaContratistas/ContratistaByDocument/" + docNumber)
  }

  getContratistaByDocumentAndDigit(docNumber: string, docType: number, digit: string) {
    return this.generalHttp.getHttp(`PacProgramaContratistas/ContratistaByDocumentAndDigit/${docNumber}/${docType}/${digit}`)
  }

  chargeMassiveContractor(objJson: any) {
    return this.generalHttp.postHttp(objJson, `${this.urlMassive}/validExcelMassiveContractor`);
  }

  getExcelMassiveContractor() {
    return this.generalHttp.getHttp(`${this.urlMassive}/excelMassiveContractor`);
  }

  getListMassiveContractor(idProgram: number) {
    return this.generalHttp.getHttp(`${this.urlMassive}/getListMassiveContractor/${idProgram}`);
  }

  getContractorByDocumentIndividual(document: string) {
    return this.generalHttp.getHttp(`${this.routeApi}/getContractorByDocument/${document}`);
  }

  getContractorByDocumentAndDigitIndividual(document: string, digit: string) {
    return this.generalHttp.getHttp(`${this.routeApi}/getContractorByDocumentAndDigit/${document}/${digit}`);
  }

  addContractorIndividual(info: any) {
    return this.generalHttp.postHttp(info, `${this.routeApi}/addContractorIndividaul`);
  }

  getContractorByDocumentPw(document: string) {
    return this.generalHttp.getHttp(`${this.routeApi}/getContractorByDocumentPw/${document}`);
  }

  getContractorsByIdProgram(idProgram: number) {
    return this.generalHttp.getHttp(`${this.routeApi}/getContractorsByIdProgram/${idProgram}`);
  }

  getAdmContratista() {
    return this.generalHttp.getHttp(this.routeApi);
  }

  getPacProgramaEmpresaByContratista(idContratista: number) {
    return this.generalHttp.getHttp(`PacProgramaContratistas/GetPacProgramaEmpresaByContratista/${idContratista}`);
  }

}
